import { Permission } from '@common/index';
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/educational-requirements',
    name: 'educationalRequirementList',
    component: () => import('../pages/EducationalRequirementListPage.vue'),
    meta: {
      requiresAuth: true,
      permission: Permission.MENU_ADMINISTRATION
    }
  }
];

export default routes;
